'use client';
import * as React from 'react';
import Elevio from './client';
import equal from 'fast-deep-equal';
import * as PropTypes from 'prop-types';
export { Elevio };
// This just keeps track of if the settings has been enabled via the server or settings
// that way when we render the component we know if we need to enable it or not
// NOTE: if the client does _elev.setSettings it won't be picked up by this.
let serverEnabled = undefined;
// TODO:
// * Convert all existing options into props.
//       # Modules + Popups ?
let mountedCount = 0;
class ElevioReact extends React.Component {
    constructor(props) {
        super(props);
        this.onReady = () => {
            if (typeof serverEnabled === 'undefined') {
                // @ts-ignore
                serverEnabled = _elev.getSetting('enabled');
            }
            this.props.onReady && this.props.onReady();
        };
        this.onLoad = (result) => this.props.onLoad && this.props.onLoad(result);
        this.onWidgetOpened = () => this.props.onWidgetOpened && this.props.onWidgetOpened();
        this.onWidgetClosed = () => this.props.onWidgetClosed && this.props.onWidgetClosed();
        this.onModuleLoaded = (result) => this.props.onModuleLoaded && this.props.onModuleLoaded(result);
        this.onModuleOpened = (result) => this.props.onModuleOpened && this.props.onModuleOpened(result);
        this.onPopupOpened = (result) => this.props.onPopupOpened && this.props.onPopupOpened(result);
        this.onPopupClosed = (result) => this.props.onPopupClosed && this.props.onPopupClosed(result);
        this.onSearchQuery = (result) => {
            this.props.onSearchQuery && this.props.onSearchQuery(result);
        };
        this.onSearchArticleClicked = (result) => this.props.onSearchArticleClicked &&
            this.props.onSearchArticleClicked(result);
        this.onCategoryArticleClicked = (result) => this.props.onCategoryArticleClicked &&
            this.props.onCategoryArticleClicked(result);
        this.onWidgetArticleView = (result) => this.props.onWidgetArticleView && this.props.onWidgetArticleView(result);
        this.onHelperClicked = (result) => this.props.onHelperClicked && this.props.onHelperClicked(result);
        this.onSuggestionsArticleClicked = (result) => this.props.onSuggestionsArticleClicked &&
            this.props.onSuggestionsArticleClicked(result);
        this.onRelatedArticleClicked = (result) => this.props.onRelatedArticleClicked &&
            this.props.onRelatedArticleClicked(result);
        this.onArticleInterlinkClicked = (result) => this.props.onArticleInterlinkClicked &&
            this.props.onArticleInterlinkClicked(result);
        this.onArticleFeedbackReaction = (result) => this.props.onArticleFeedbackReaction &&
            this.props.onArticleFeedbackReaction(result);
        this.onArticleFeedbackText = (result) => this.props.onArticleFeedbackText &&
            this.props.onArticleFeedbackText(result);
        this.onArticleKBlinkClicked = (result) => this.props.onArticleKBlinkClicked &&
            this.props.onArticleKBlinkClicked(result);
        this.onPageView = (result) => this.props.onPageView && this.props.onPageView(result);
        this.onArticleDataLoaded = (result) => this.props.onArticleDataLoaded && this.props.onArticleDataLoaded(result);
        this.onArticleDataError = (result) => this.props.onArticleDataError && this.props.onArticleDataError(result);
        this.onCategoryDataLoaded = (result) => this.props.onCategoryDataLoaded && this.props.onCategoryDataLoaded(result);
        this.onArticleFeedbackLoading = (result) => this.props.onArticleFeedbackLoading &&
            this.props.onArticleFeedbackLoading(result);
        this.onArticleFeedbackLoaded = (result) => this.props.onArticleFeedbackLoaded &&
            this.props.onArticleFeedbackLoaded(result);
        this.onArticleFeedbackError = (result) => this.props.onArticleFeedbackError &&
            this.props.onArticleFeedbackError(result);
        this.onArticleRelatedLoaded = (result) => this.props.onArticleRelatedLoaded &&
            this.props.onArticleRelatedLoaded(result);
        this.onSuggestionsDataLoaded = (result) => this.props.onSuggestionsDataLoaded &&
            this.props.onSuggestionsDataLoaded(result);
        this.onSuggestionsDataError = (result) => this.props.onSuggestionsDataError &&
            this.props.onSuggestionsDataError(result);
        Elevio.on('ready', this.onReady);
        Elevio.on('widget:opened', this.onWidgetOpened);
        Elevio.on('widget:closed', this.onWidgetClosed);
        Elevio.on('module:loaded', this.onModuleLoaded);
        Elevio.on('module:opened', this.onModuleOpened);
        Elevio.on('popup:opened', this.onPopupOpened);
        Elevio.on('popup:closed', this.onPopupClosed);
        Elevio.on('search:query', this.onSearchQuery);
        Elevio.on('search:article:clicked', this.onSearchArticleClicked);
        Elevio.on('category:article:clicked', this.onCategoryArticleClicked);
        Elevio.on('widget:article:view', this.onWidgetArticleView);
        Elevio.on('helper:clicked', this.onHelperClicked);
        Elevio.on('suggestions:article:clicked', this.onSuggestionsArticleClicked);
        Elevio.on('related:article:clicked', this.onRelatedArticleClicked);
        Elevio.on('article:interlink:clicked', this.onArticleInterlinkClicked);
        Elevio.on('article:feedback:reaction', this.onArticleFeedbackReaction);
        Elevio.on('article:feedback:text', this.onArticleFeedbackText);
        Elevio.on('article:kblink:clicked', this.onArticleKBlinkClicked);
        Elevio.on('page:view', this.onPageView);
        Elevio.on('article:data:loaded', this.onArticleDataLoaded);
        Elevio.on('article:data:error', this.onArticleDataError);
        Elevio.on('category:data:loaded', this.onCategoryDataLoaded);
        Elevio.on('article:feedback:loading', this.onArticleFeedbackLoading);
        Elevio.on('article:feedback:loaded', this.onArticleFeedbackLoaded);
        Elevio.on('article:feedback:error', this.onArticleFeedbackError);
        Elevio.on('article:related:loaded', this.onArticleRelatedLoaded);
        Elevio.on('suggestions:data:loaded', this.onSuggestionsDataLoaded);
        Elevio.on('suggestions:data:error', this.onSuggestionsDataError);
    }
    componentDidMount() {
        mountedCount++;
        if (mountedCount > 1) {
            console.warn(`Multiple instances of the elevio component being rendered, this will lead to unexpected results. Please only use one.`);
        }
        const { accountId } = this.props;
        const urlOverride = (this.props.developerOptions &&
            this.props.developerOptions.urlOverride) ||
            undefined;
        Elevio.load(accountId, {
            urlOverride,
        }).then((_elev) => {
            // Wait until Elevio has loaded before setting settings.
            if (this.props.keywords)
                Elevio.setKeywords(this.props.keywords);
            if (this.props.language)
                Elevio.setLanguage(this.props.language);
            if (this.props.user)
                Elevio.setUser(this.props.user);
            if (this.props.settings)
                Elevio.setSettings(this.props.settings);
            if (this.props.pageUrl)
                Elevio.setPage(this.props.pageUrl);
            if (this.props.translations)
                Elevio.setTranslations(this.props.translations);
            if (serverEnabled) {
                Elevio.enable();
            }
            this.onLoad(_elev);
        });
    }
    componentWillUnmount() {
        Elevio.disable();
        mountedCount--;
    }
    componentDidUpdate(prevProps) {
        if (!equal(this.props.keywords, prevProps.keywords)) {
            Elevio.setKeywords(this.props.keywords);
        }
        if (this.props.language !== prevProps.language) {
            Elevio.setLanguage(this.props.language);
        }
        // Check the user
        if (!equal(this.props.user, prevProps.user)) {
            // Either update if user has change, or log them out.
            if (this.props.user) {
                Elevio.setUser(this.props.user);
            }
            else {
                Elevio.logoutUser();
            }
        }
        if (this.props.accountId !== prevProps.accountId) {
            Elevio.setAccountId(this.props.accountId);
        }
        if (this.props.settings &&
            !equal(this.props.settings, prevProps.settings)) {
            if (this.props.settings.enabled) {
                serverEnabled = this.props.settings.enabled;
            }
            Elevio.setSettings(this.props.settings);
        }
        if (this.props.pageUrl !== prevProps.pageUrl) {
            Elevio.setPage(this.props.pageUrl);
        }
        if (!equal(this.props.translations, prevProps.translations)) {
            Elevio.setTranslations(this.props.translations);
        }
    }
    render() {
        return null;
    }
}
ElevioReact.propTypes = {
    accountId: PropTypes.string.isRequired,
    options: PropTypes.object,
    keywords: PropTypes.arrayOf(PropTypes.string),
    language: PropTypes.string,
    user: PropTypes.object,
    settings: PropTypes.object,
    pageUrl: PropTypes.string,
    translations: PropTypes.object,
    onLoad: PropTypes.func,
    onReady: PropTypes.func,
    onWidgetOpened: PropTypes.func,
    onWidgetClosed: PropTypes.func,
    onModuleLoaded: PropTypes.func,
    onModuleOpened: PropTypes.func,
    onPopupOpened: PropTypes.func,
    onPopupClosed: PropTypes.func,
    onHelperClicked: PropTypes.func,
    onSearchQuery: PropTypes.func,
    onSearchArticleClicked: PropTypes.func,
    onCategoryArticleClicked: PropTypes.func,
    onWidgetArticleView: PropTypes.func,
    onSuggestionsArticleClicked: PropTypes.func,
    onRelatedArticleClicked: PropTypes.func,
    onArticleInterlinkClicked: PropTypes.func,
    onArticleFeedbackReaction: PropTypes.func,
    onArticleFeedbackText: PropTypes.func,
    onArticleKBlinkClicked: PropTypes.func,
    onPageView: PropTypes.func,
    onArticleDataLoaded: PropTypes.func,
    onArticleDataError: PropTypes.func,
    onCategoryDataLoaded: PropTypes.func,
    onArticleFeedbackLoading: PropTypes.func,
    onArticleFeedbackLoaded: PropTypes.func,
    onArticleFeedbackError: PropTypes.func,
    onArticleRelatedLoaded: PropTypes.func,
    onSuggestionsDataLoaded: PropTypes.func,
    onSuggestionsDataError: PropTypes.func,
};
export default ElevioReact;
